export type ThemeName = 'atelier' | 'atelier-dark'

export const DEFAULT_THEME: ThemeName = 'atelier'

export const THEME_STORAGE_KEY = 'crm-agent-python-theme'

export const THEME_LABELS: Record<ThemeName, string> = {
  atelier: 'Light',
  'atelier-dark': 'Dark',
}

export interface ThemePalette {
  '--color-ink': string
  '--color-ink-raised': string
  '--color-cream': string
  '--color-mute': string
  '--color-haze': string
  '--color-ember': string
  '--color-leaf': string
  '--color-sky': string
  '--color-selection-bg': string
  '--color-selection-text': string
    '--shadow-form': string
  '--shadow-button': string
  '--shadow-elevated': string
}

export const palettes: Record<ThemeName, ThemePalette> = {
  atelier: {
    '--color-ink': '#F7F7F4',
    '--color-ink-raised': '#FFFFFF',
    '--color-cream': '#1E2326',
    '--color-mute': '#687176',
    '--color-haze': '#DADFDA',
    '--color-ember': '#2F6F5E',
    '--color-leaf': '#4F725D',
    '--color-sky': '#4D6F82',
    '--color-selection-bg': '#DCE9E2',
    '--color-selection-text': '#1E2326',
    '--shadow-form': '0 1px 2px rgba(30, 35, 38, 0.08)',
    '--shadow-button': '0 2px 6px rgba(47, 111, 94, 0.22)',
    '--shadow-elevated': '0 1px 2px rgba(30, 35, 38, 0.06), 0 8px 20px rgba(30, 35, 38, 0.08)',
  },
  'atelier-dark': {
    '--color-ink': '#151819',
    '--color-ink-raised': '#202526',
    '--color-cream': '#F4F1EA',
    '--color-mute': '#9AA4A3',
    '--color-haze': '#323B3B',
    '--color-ember': '#77B49D',
    '--color-leaf': '#8DB58F',
    '--color-sky': '#84A8B8',
    '--color-selection-bg': '#2B463C',
    '--color-selection-text': '#F4F1EA',
    '--shadow-form': '0 1px 2px rgba(0, 0, 0, 0.30)',
    '--shadow-button': '0 2px 8px rgba(119, 180, 157, 0.20)',
    '--shadow-elevated': '0 1px 2px rgba(0, 0, 0, 0.25), 0 10px 28px rgba(0, 0, 0, 0.24)',
  },
}

export function isValidTheme(value: string | null): value is ThemeName {
  return value === 'atelier' || value === 'atelier-dark'
}
